import {ChangeDetectorRef, NgZone, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import moment, {Moment} from 'moment';

@Pipe({ name: 'momentPipe' })
export class MomentPipePipe implements PipeTransform {

  transform(date, format) {
    return moment(date).format(format);
  }

}

@Pipe({name: 'momentFromNowPipe'})
export class MomentFromNowPipe implements PipeTransform {

  transform(date: string | Date | Moment): string {
    return date ? moment(date).fromNow() : '';
  }

}

@Pipe({name: 'momentDiffPipe', pure: false})
export class MomentDiffPipe implements PipeTransform, OnDestroy {
  private timer: number;

  constructor(private cd: ChangeDetectorRef, private ngZone: NgZone) {
  }

  transform(date: Moment): string {
    if (!date) {
      return '';
    }
    if (!this.timer) {
      this.ngZone.runOutsideAngular(() => {
        this.timer = window.setInterval(() => {
          this.ngZone.run(() => {
            this.cd.markForCheck();
          });
        }, 1000);
      });
    }

    return moment().diff(date, 'seconds') + 's';
  }

  ngOnDestroy(): void {
    this.removeTimer();
  }

  private removeTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}
